module.exports = __webpack_public_path__ + "img/8.15f589c0.jpg";